$(".cookiesMain .cookiesAgree").click(function () {
    openCookiesModal(true);

    return false;
});


$(".cookiesMain .cookiesDisagree").click(function () {
    openCookiesModal(false);

    return false;
});


$(".cookiesModal .cookiesSave").click(function () {
    sendCookies();

    hideCookiesModal();

    return false;
});


$(".cookiesModal .cookiesClose").click(function () {
    hideCookiesModal();

    return false;
});


$(".cookiesModal input[type=checkbox]").click(function () {
    $(".cookiesModal .cookiesClose").slideUp();
    $(".cookiesModal .cookiesSave").slideDown();
});


function openCookiesModal(cookies) {
    $(".cookiesMain").fadeOut();

    $(".cookiesModal").show().css("bottom", -$(".cookiesModal").height()).hide();

    if (cookies) {
        $(".cookiesModal input").attr("checked", true);
    }

    sendCookies();

    setTimeout(function () {
        $(".cookiesModal").show().css("bottom", 0);
    }, 50);
}


function hideCookiesModal() {
    $(".cookiesModal").css("bottom", -$(".cookiesModal").height());

    setTimeout(function () {
        $(".cookiesModal").hide();
    }, 500);
}


function sendCookies() {
    var cookies = "";

    $(".cookiesModal input[type=checkbox]").each(function () {
        if ($(this).is(":checked"))
            cookies += $(this).attr("name") + ";";
    });

    cookies = cookies.substring(0, cookies.length - 1);

    $.get("?set-cookies=" + cookies);
}
